import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { DropsContext } from 'contexts/DropsContext';
import { ProdutosContext } from 'contexts/ProdutosContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Loader from 'components/Loader';
import Header from 'components/Header';
import Button from 'components/Button';
import Card from 'components/Card';
import api from 'services/api';

const Etiquetas = () => {
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [etiquetas, setEtiquetas] = useState([]);
  const { drops } = useContext(DropsContext);
  const { postLoading, postEtiquetas } = useContext(ProdutosContext);
  const { control, handleSubmit, watch, resetField } = useForm({
    defaultValues: { impressora_id: null, modelo_id: null },
  });

  const loadEtiquetas = async (ids = []) => {
    try {
      setLoading(true);
      const { data } = await api.post('/Cadastros/Produto/Multiple', ids);

      const renderEtiquetas = [];
      data?.map((d) => {
        const Variacoes = d?.ProdutoVariacaos?.filter(
          (v) => v?.ativo === 'SIM'
        );
        const produto = {
          produto_id: d?.id,
          referencia: d?.referencia,
          produto: d?.ProdutoDescricaos?.find(
            (d) => d?.tipo === 'COMPLETA' || d?.tipo === 'REDUZIDA'
          )?.descricao,
          quantidade: 1,
          localizador: d?.localizador,
          cdbarra: d?.cdbarra,
        };
        if (Boolean(Variacoes?.length)) {
          Variacoes?.map((v) =>
            renderEtiquetas?.push({
              ...produto,
              variacao_id: v?.id,
              variacao: v?.variacao,
            })
          );
        } else {
          renderEtiquetas?.push({ ...produto, variacao: null });
        }
      });
      setEtiquetas(renderEtiquetas?.map((e, id) => ({ ...e, id })));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onCellEditCommit = (e) => {
    const editedRows = etiquetas?.map((c) => {
      if (c?.id === e?.id) {
        return { ...c, [e?.field]: e?.value };
      } else {
        return { ...c };
      }
    });
    setEtiquetas(editedRows);
  };

  const onSubmit = (values) => {
    postEtiquetas({
      data: {
        ...values,
        produtos: etiquetas?.map((e) => ({
          produto_id: e?.produto_id,
          variacao_id: e?.variacao_id,
          cdbarra: e?.cdbarra,
          quantidade: e?.quantidade,
        })),
      },
    });
  };

  useEffect(() => {
    loadEtiquetas(state?.produtos);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      <Header titulo="Imprimir Etiquetas" />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="impressora_id"
              control={control}
              label="Impressora"
              options={drops?.Impressoraweb}
              onValueChange={() => resetField('modelo_id')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="modelo_id"
              control={control}
              label="Modelo"
              options={drops?.EtiquetaModelo?.filter(
                (f) => f?.impressoraweb_id === watch('impressora_id')
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <DataGrid
              rows={etiquetas}
              columns={[
                {
                  field: 'referencia',
                  headerName: 'Referência',
                  width: 200,
                  sortable: false,
                },
                {
                  field: 'produto',
                  headerName: 'Produto',
                  flex: 1,
                  minWidth: 400,
                  sortable: false,
                },
                {
                  field: 'variacao',
                  headerName: 'Variação',
                  width: 200,
                  sortable: false,
                },
                {
                  field: 'localizador',
                  headerName: 'Localizador',
                  width: 200,
                  sortable: false,
                },
                {
                  field: 'cdbarra',
                  headerName: 'Código de Barras',
                  width: 300,
                  editable: true,
                  sortable: false,
                },
                {
                  field: 'quantidade',
                  headerName: 'Quantidade',
                  type: 'number',
                  width: 200,
                  editable: true,
                  sortable: false,
                },
              ]}
              hideFooter
              autoHeight
              density="compact"
              disableSelectionOnClick
              disableColumnMenu
              showCellRightBorder
              showColumnRightBorder
              localeText={{ noRowsLabel: 'Nenhum Registro.' }}
              onCellEditCommit={onCellEditCommit}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Imprimir
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Etiquetas;
